import { create as actualCreate } from 'zustand'

const storeResetFns = new Set()

export const resetAllStores = () => {
  // Delay 500ms trước khi reset store
  setTimeout(() => {
    storeResetFns.forEach((resetFn) => {
      resetFn()
    })
  }, 500)
}

export const create = (stateCreator) => {
  const store = actualCreate(stateCreator)
  const initialState = store.getInitialState()
  storeResetFns.add(() => {
    store.setState(initialState, true)
  })
  return store
}
